import { render, staticRenderFns } from "./AirlineVendor.vue?vue&type=template&id=7530b198&"
import script from "./AirlineVendor.vue?vue&type=script&lang=js&"
export * from "./AirlineVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports